import C from '../actions/constants'

export const solidRate = (state = {}, action) => {
    switch (action.type) {
        case C.SET_SOLID_RATE_VALUES:
            return { ...state, ...action.payload }
        default:
            return state
    }
}